import { FC } from 'react';

import { useIntl } from 'react-intl';

import { ListCardGroup } from 'components/list-card-group';

import { Modifier } from '../modifier/modifier';
import { IModifierData } from '../modifier/types';

import { SelectModifierFn } from './types';

export interface IModifierGroup {
  key: string;
  displayGroupName?: string;
  modifiers: IModifierData[];
}

export type IModifierGroupProps = IModifierGroup & {
  onModifierSelectionChange: SelectModifierFn;
};

export const ModifierGroup: FC<IModifierGroupProps> = ({
  displayGroupName,
  modifiers,
  onModifierSelectionChange,
}) => {
  const { formatMessage } = useIntl();

  return (
    <ListCardGroup
      items={modifiers}
      header={displayGroupName ? formatMessage({ id: displayGroupName }) : undefined}
      renderItem={({ item: modifierProps }: { item: IModifierData }) => (
        <Modifier
          {...modifierProps}
          key={`modifier-${modifierProps.modifier.id}`}
          onSelectionsChange={selections =>
            onModifierSelectionChange(selections, modifierProps.modifier)
          }
        />
      )}
    />
  );
};
